<template>
  <div class="bootcard-see-bd">
    <custom-dialog :title="model.title" :visible="visible" v-on="$listeners" width="500px">
      <div class="dialog-body">
        <div class="information-body">
          <el-row>
            <el-col :span="8">
              {{ 'RFID' }}
            </el-col>
            <el-col :span="16">
              {{ info.rfid }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              {{ $t('dms_bootCard_see_dialog.ka_mian_bian_hao') }}
            </el-col>
            <el-col :span="16">
              {{ info.cardNum }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              {{ $t('dms_bootCard_see_dialog.yan_se') }}
            </el-col>
            <el-col :span="16">
              {{ dms_boot_card_color[info.cardColor] }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              {{ $t('Common.com_status') }}
            </el-col>
            <el-col :span="16">
              {{ dms_boot_card_state[info.state] }}
            </el-col>
          </el-row>
          <el-row class="dec">
            <el-col :span="24">
              {{ $t('Common.com_remark') }}
            </el-col>
            <el-col :span="24" class="grid-content">
              {{ info.cardDesc }}
            </el-col>
          </el-row>
        </div>
        <div class="related-body" v-if="info.deviceList&&info.deviceList.length">
          <p>
            {{ $t('dms_bootCard_see_dialog.yi_guan_lian_she_bei') }}
          </p>
          <custom-table
            tableCode="device_card_details"
            :data="info.deviceList"
            :index="true"
            height="200px"
          >
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      info: {
        title: '',
        beginTime: '',
        endTime: '',
        isPop: '',
        state: '',
        publishTime: '',
        content: '',
        pushChannelName: '',
        pushRoleName: '',
        pushRangeName: '',
        creator: '',
        gmtCreate: '',
      },
      dms_boot_card_color: {},
      dms_boot_card_state: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.getDictionary('dms_boot_card_color,dms_boot_card_state', (data) => {
        this.dms_boot_card_color = this.$transformDicValue(data.dms_boot_card_color);
        this.dms_boot_card_state = this.$transformDicValue(data.dms_boot_card_state);
      });

      if (this.model.type === 'see') {
        this.getBootCardInfo();
      }
    },

    getBootCardInfo: function () {
      this.$getJSON(apis.bootCardInfo, { cardId: this.model.cardId }).then((res) => {
        this.info = res.data;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.bootcard-see-bd {
  .information-body,
  .related-body {
    .el-row {
      color: #6c757d;
      font-size: 12px;
      line-height: 35px;
      border-bottom: 1px solid #eef2f7;
      > .el-col:first-child {
        font-size: 12px;
        // font-weight:bold;
        color: #6c757d;
        line-height: 35px;
      }
      > .el-col:last-child {
        font-size: 12px;
        color: #6c757d;
        line-height: 35px;
        text-align: right;
      }
    }
    .el-row.dec {
      padding: 9px 0;
      > .el-col:first-child {
        line-height: 17px;
      }
      > .el-col:last-child {
        margin-top: 6px;
        line-height: 17px;
        text-align: left;
        color: #98a6ad;
      }
    }
  }
  .related-body {
    p {
      height: 60px;
      font-size: 12px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }
    .dec {
      .title {
        height: 17px;
        font-size: 12px;
        color: rgba(108, 117, 125, 1);
        line-height: 17px;
      }
      .card-list,
      .el-col:last-child {
        margin-top: 12px !important;
        height: 17px;
        font-size: 12px;
        color: #98a6ad;
        line-height: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .number {
          flex: 1;
          color: #98a6ad;
        }
        .state {
          color: #98a6ad;
        }
      }
    }
  }
}
</style>
